import { createElement } from "@wordpress/element";
/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Popover } from '@wordpress/components';

/**
 * Internal dependencies
 */
import BlockPreview from '../block-preview';
export default function PreviewBlockPopover({
  blocks
}) {
  return createElement("div", {
    className: "block-editor-block-switcher__popover__preview__parent"
  }, createElement("div", {
    className: "block-editor-block-switcher__popover__preview__container"
  }, createElement(Popover, {
    className: "block-editor-block-switcher__preview__popover",
    placement: "bottom-start",
    focusOnMount: false
  }, createElement("div", {
    className: "block-editor-block-switcher__preview"
  }, createElement("div", {
    className: "block-editor-block-switcher__preview-title"
  }, __('Preview')), createElement(BlockPreview, {
    viewportWidth: 500,
    blocks: blocks
  })))));
}
//# sourceMappingURL=preview-block-popover.js.map